(() => {
  function initCollectionTabs() {
    document
      .querySelectorAll('.collections-with-tabs')
      .forEach((section) => {
        if (section.dataset.tabsInitialized === 'true') {
          return;
        }

        const tabItems = section.querySelectorAll(
          '.tabs-navigation-item'
        );

        const tabSelect = section.querySelector(
          '.tabs-navigation-select'
        );

        const productLists = section.querySelectorAll(
          '[data-tab-id]'
        );

        const activateTab = (tabId) => {
          if (!tabId) return;

          tabItems.forEach((item) => {
            item.classList.toggle(
              'active',
              item.dataset.tab === tabId
            );
          });

          productLists.forEach((list) => {
            list.classList.toggle(
              'active',
              list.dataset.tabId === tabId
            );
          });

          if (
            tabSelect &&
            tabSelect.value !== tabId
          ) {
            tabSelect.value = tabId;
          }
        };

        section.addEventListener('click', (event) => {
          const item = event.target.closest(
            '.tabs-navigation-item'
          );

          if (!item) return;

          activateTab(item.dataset.tab);
        });

        section.addEventListener('keydown', (event) => {
          const item = event.target.closest(
            '.tabs-navigation-item'
          );

          if (!item) return;

          if (
            event.key !== 'Enter' &&
            event.key !== ' '
          ) {
            return;
          }

          event.preventDefault();

          activateTab(item.dataset.tab);
        });

        if (tabSelect) {
          tabSelect.addEventListener(
            'change',
            () => {
              activateTab(tabSelect.value);
            }
          );
        }

        section.dataset.tabsInitialized = 'true';
      });
  }

  document.addEventListener(
    'DOMContentLoaded',
    initCollectionTabs
  );

  document.addEventListener(
    'shopify:section:load',
    initCollectionTabs
  );
})();